import { lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const ParticleBackground = lazy(() =>
  import("./ParticleBackground").then((m) => ({ default: m.ParticleBackground })),
);

export function ContactSection() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-20 bg-gradient-dark relative overflow-hidden">
      {/* Particle animation background */}
      <Suspense fallback={null}>
        <ParticleBackground />
      </Suspense>
      
      {/* Subtle gradient overlays */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[300px] bg-secondary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[250px] bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
            {t("contact.title")}
          </h2>
          <p className="text-primary-foreground/60 text-lg mb-10">
            {t("contact.desc")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <a
              href="https://www.deep-insights.ai/book-demo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="outline"
                size="lg"
                className="bg-primary-foreground text-primary hover:bg-secondary hover:text-primary-foreground border-0 px-8 h-12 text-base font-medium transition-colors"
              >
                {t("cta.demo")}
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
